<template>
 <div class="section fondu" :class="{'fonduenter': content.name}">

  <!-- notification -->
  <transition mode="out-in" name="fade">
   <div v-if="notification.message" :class="'notification is-' + notification.type">
     <button class="delete" @click="hideNotifications"></button>{{notification.message}}
   </div>
  </transition>

  <!-- modal for post delete -->
  <transition mode="out-in" name="fade">
    <modal @close="showModal = false" :kind="kind" @confirmDeleteContent='confirmDeleteContent()' @selectBulkActions='selectBulkActions()' v-if="showModal" :header="header"/>
  </transition>

  <div class="card">
     <div class="card-header">
       <p class="card-header-title">Contenu {{ content.name }}</p>
       <span class="icon has-text-info help-btn">
         <a href="https://theadmin.thecompagnie.eu/doc?bloc=Type%20de%20contenu%20multiples" target="_blank"><i class="fa fa-question-circle"></i></a>
       </span>
     </div>
     <div class="card-content principal">
       <div class="content">
         <div class="card" v-if="!content.single">
           <div class="card-header">
             <p class="card-header-title">Recherche</p>
           </div>
           <div class="card-content">
             <div class="content">
               <div class="field is-grouped" v-if="!content.single">
                 <p class="control is-expanded">
                   <input class="input" type="text" :placeholder="'Rechercher dans ' + content.name + '...'"> <!--  v-model="searchPost" -->
                 </p>
                 <p class="control">
                   <a class="button is-info">
                     Rechercher
                   </a>
                 </p>
               </div>
             </div>
           </div>
         </div>
         <br  v-if="!content.single"/>
         <router-link :to="'/admin/content/' + $route.params.key + '/new'" class="button is-fullwidth is-info" v-if="!content.single || !content.data">Ajouter nouveau</router-link>
         <br  v-if="!content.single"/>
         <router-view :add-content="addContent" :fields="content.fields" :update-content="updateContent" :contents="contentData" :key="$route.name + ($route.params.key || '')"></router-view>
         <br  v-if="!content.single"/>
         <div class="card" v-if="!content.single">
           <div class="card-header">
             <p class="card-header-title">Contenus dans {{ content.name }}</p>
             <span class="icon has-text-info help-btn">
               <a href="https://theadmin.thecompagnie.eu/doc?bloc=Type%20de%20contenu%20multiple" target="_blank"><i class="fa fa-question-circle"></i></a>
             </span>
           </div>
           <div class="card-content">
             <div class="content">
               <div class="filters" v-if="false">
                 <div class="states">
                   <a class="state" @click="selectedState = 'all'" :class="{ 'activeState': selectedState === 'all' }">
                     Tous<span class="stateCnt">({{ allContents }})</span>
                   </a>|
                   <a class="state" @click="selectedState = 'published'" :class="{ 'activeState': selectedState === 'published' }">
                     Publié<span class="stateCnt">({{ publishedContent.length}})</span>
                   </a>|
                   <a class="state" @click="selectedState = 'saved'" :class="{ 'activeState': selectedState === 'saved' }">
                     Archivé<span class="stateCnt">({{ savedContent.length}})</span>
                   </a>
                 </div>
               </div>
               <dropdown :options="bulkActions" :selectedElement="params.bulkAction" @selectBulkActions="selectBulkActions()" @bulkDelete="bulkDelete()"/>
               <!-- Contents list -->
               <table v-if="!content.single" class="table is-fullwidth is-striped">
                 <thead>
                   <tr>
                     <th>
                       date création
                     </th>
                     <th v-for="(field, fieldKey) in contentData[0]" :key="fieldKey" v-if="findField(fieldKey)">
                       {{ fieldKey }}
                     </th>
                     <th class="actions">
                       Actions
                     </th>
                   </tr>
                 </thead>
                 <tbody>
                   <tr v-for="(content, index) in filteredContent" :key="index">
                     <td class="post-title-cell">
                       <checkbox v-model="content.selected" />
                       {{ formatDate(content.created) }}
                     </td>
                     <td class="post-title-cell" v-for="(field, fieldKey) in filteredContent[index]" :key="fieldKey" v-if="findField(fieldKey)">
                       {{ field }}
                     </td>
                     <td class="actions">
                       <router-link :to="'/admin/content/' + $route.params.key + '/edit/' + content['.key']">
                         <span class="has-text-info"><i class="fa fa-pencil"></i></span>
                       </router-link>
                       <span @click="deleteContent(content)" class="has-text-danger"><i class="fa fa-trash"></i></span>
                     </td>
                   </tr>
                 </tbody>
               </table>
             </div>
           </div>
         </div>
       </div>
     </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { contentsRef, db } from '@/admin/firebase_config'
import notifier from '@/admin/mixins/notifier'
import modal from '@/admin/components/shared/Modal'
import dropdown from '@/admin/components/shared/Dropdown'
import checkbox from '@/admin/components/shared/Checkbox'
import contentFilters from '@/admin/mixins/contentFilters'

export default {
  name: 'contents',
  data () {
    return {
      // contentData: [],
      selContent: null,
      showModal: false,
      header: '',
      kind: '',
      sortKey: 'tittle',
      loaded: false
    }
  },
  firebase: {
    contents: contentsRef
  },
  mixins: [notifier, contentFilters],
  mounted () {
    this.loaded = true
  },
  computed: {
    content () {
      const contenttoreturn = Object.assign(
        {},
        (this.contents.filter((content) => {
          return (content['.key'] === this.$route.params.key)
        }))[0]
      )
      this.$bindAsArray('contentData', db.ref('contents/' + this.$route.params.key + '/data'))
      return contenttoreturn
    },
    allContents () {
      return this.contentData.length
    },
    savedContent () {
      return this.contentData
        .filter(content => {
          if (content.state === 'saved') {
            return true
          }
        })
    },
    publishedContent () {
      return this.contentData
        .filter(content => {
          if (content.state === 'published') {
            return true
          }
        })
    }
  },
  methods: {
    findField (field) {
      for (var key in this.content.fields) {
        if (this.content.fields[key].name.toLowerCase() === field) {
          if (this.content.fields[key].sortable) {
            return true
          }
        }
      }
      return false
    },
    formatDate (epoch) {
      if (!epoch) return // if no time return nothing
      return moment(epoch).format('DD/MM/YY | hh:mm')
    },
    addContent (content) {
      this.$firebaseRefs.contents.child(this.$route.params.key + '/data')
        .push(content)
        .then(() => {
          this.showNotification('success', 'Contenu ajouté avec succès')
        })
    },
    deleteContent (content) {
      // delete content form firebase
      this.header = 'Êtes-vous certain de vouloir supprimer ce contenu ?'
      this.kind = 'deleteContent'
      this.showModal = true
      this.selContent = content
    },
    bulkDelete () {
      if (this.selectedContent.length) {
        this.header = 'Êtes-vous certain de vouloir supprimer les contenus sélectionnés ?'
        this.kind = 'bulkDeleteSelected'
        this.showModal = true
      }
    },
    confirmDeleteContent () {
      this.$firebaseRefs.contents.child(this.$route.params.key + '/data').child(this.selContent['.key']).remove()
        .then(() => {
          this.showNotification('success', 'Contenu supprimé avec succès')
          this.showModal = false
          this.selContent = ''
        })
    },
    updateContent (content) {
      console.log(JSON.stringify(content), content)
      // create a copy of the item
      let tempCon = { ...content }
      // remove the .key attribute
      delete tempCon['.key']
      this.$firebaseRefs.contents.child(this.$route.params.key + '/data').child(content['.key']).set(tempCon)
        .then(() => {
          if (content.state === 'saved') {
            this.showNotification('success', 'Contenu modifié avec succès')
          }
          if (content.state === 'published') {
            this.showNotification('success', 'Contenu modifié et publié avec succès')
          }
        })
    }
  },
  components: {
    modal,
    dropdown,
    checkbox
  }
}

</script>

<style lang="scss" scoped>
  .actions{
    text-align: right !important;
  }
  .section{
    padding: 0 !important;
    padding-top: 1em !important;
  }
  .bulma .card .card-content.principal{
    padding: 0 !important;
  }
  .bulma .card-content{
    padding: 0 !important;
  }
  .bulma .columns{
    padding: 0 !important;
  }
  .bulma .column{
    padding: 0 !important;
  }
  .content{
    padding: 1em !important;
  }
</style>



// WEBPACK FOOTER //
// src/admin/pages/content/contents/Contents.vue